// src/store/api/userApiSlice.js
import { apiSlice } from "./apiSlice";

export const userApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getUserSubjects: builder.query({
			query: () => "/Teacher/current/subjects",
			providesTags: ["Subjects"],
		}),

		getUserDepartments: builder.query({
			query: () => "/Teacher/current/departments",
			providesTags: ["Departments"],
		}),

		getUserClassDepartments: builder.query({
			query: () => "/Teacher/current/class-departments",
			providesTags: ["ClassDepartments"],
		}),

		getCurrentTeacherSubstituteSubject: builder.query({
			query: () => "/Teacher/current/substitute-subject",
			providesTags: [{ type: "Teacher", id: "SUBSTITUTE" }],
		}),
	}),
});

export const {
	useGetUserSubjectsQuery,
	useGetUserDepartmentsQuery,
	useGetUserClassDepartmentsQuery,
	useGetCurrentTeacherSubstituteSubjectQuery,
} = userApiSlice;
